import {combineReducers} from "redux";
import renderReducer from "./RenderReducer";
import searchReducer from "./SearchReducer";
import wizardReducer from "./WizardReducer";
import ricercaAssistenteReducer from "./RicercaAssistenteReducer";
import fileReducer from "./FileReducer";

const rootReducer = combineReducers({
    renderReducer: renderReducer,
    searchReducer: searchReducer,
    wizardReducer: wizardReducer,
    ricercaAssistenteReducer:ricercaAssistenteReducer,
    fileReducer: fileReducer
})

export default rootReducer;
